export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
	'Non-Error exception captured',
	// MSAL noise: concurrent interactions, iframe crypto restrictions, stale auth state
	'interaction_in_progress',
	'crypto_nonexistent',
	'block_iframe_reload',
	'endpoints_resolution_error',
	'authority_mismatch',
	// Dynamic chunk-load failures after a deploy (user's browser holds a stale bundle)
	'Failed to fetch dynamically imported module',
	'error loading dynamically imported module',
	'Importing a module script failed',
];
